export default __webpack_public_path__ + "static/media/profilePlaceholder.3be3565e.svg";